import { Button, Col, Input, Row, Space } from "antd";
import { useState } from "react";
import Icon from "../../assets/icons/icon";
import { renderErrorMessage } from "../../components/messages/errorMessage";
import { useTaxLegalId } from "../../contexts/taxLegalCaseStore";
import _t from "../../lang/translate";
import { storeTaxLegalEntityRecording } from "../../services/entityRecordingService";
import { EntityRecording } from "../../types/entityRecordingTypes";

const MAX_NOTE_CHARACTERS = 2048;
type Props = {
  onSubmit: (event: EntityRecording) => void
}
export function AddCaseNote({ onSubmit }: Props) {
  const caseId = useTaxLegalId()
  const [note, setNote] = useState('')
  const [loading, setLoading] = useState(false)

  async function submit(isPublic: boolean = false) {
    try {
      setLoading(true)
      const { data } = await storeTaxLegalEntityRecording(caseId, {
        eventType: "note_added",
        payload: { content: note },
        isImportant: false,
        isPublic
      });
      onSubmit(data.data)
      setNote('')
    } catch (error) {
      renderErrorMessage(error)
    } finally {
      setLoading(false)
    }
  }
  return (
    <div>
      <Input.TextArea value={note} onChange={e => setNote(e.target.value)}
        className="noresize-text-area"
        placeholder={_t("note")}
        maxLength={MAX_NOTE_CHARACTERS}
        autoSize={{ minRows: 3, maxRows: 5 }}
      />
      <Row justify="space-between" className="mt-05">
        <Col>
          <small className="muted">{note.length} / {MAX_NOTE_CHARACTERS} {_t("letters").toLowerCase()}</small>
        </Col>
        <Col>
          <Space size="small">
            <Button onClick={() => submit(false)} icon={<Icon name="list-plus" />} loading={loading}>
              {_t("add", "internalNote")}</Button>
            <Button onClick={() => submit(true)} icon={<Icon name="paper-plane-outline" />} type="primary" loading={loading}>
              {_t("add")}</Button>
          </Space>
        </Col>
      </Row>
    </div>
  )
}
